import axios from "axios";
import Config from "../utils/Config";
import Middleware from "./Middleware";

class SettingsService {
    config = {
        headers: {
            Authorization: "",
            CompanyId: "",
        },
    };

    //set access token
    setAccessToken(accessToken, companyId) {
        this.config.headers.Authorization = accessToken;
        this.config.headers.CompanyId = companyId;
    }

    //get profile image by user detail id
    async geteProfileImageByUserDetailsId (userDetailsId, companyId, accessToken){
        this.setAccessToken(accessToken, companyId);
        const res = await Middleware.api.get(
            `/api/userDetails/profilePicture/${userDetailsId}`,
            this.config
        )
        return res.data;
    }
};

export default new SettingsService();